import React from 'react';
import Logo from './Logo';

export default function Nav({ children, style }) {
  return (
    <nav className="ik-nav" style={style}>
      <Logo size="sm" />
      {children}
    </nav>
  );
}
